import { useState } from "react";
import {
    DesvincularEquipeVendasUsuarioController,
    ListarEquipeVendasDesvinculadosPorUsuarioController,
    ListarEquipeVendasVinculadosPorUsuarioController,
    VincularEquipeVendasUsuarioController,
} from "../../../../../Controllers/Geral/EquipeVendas/EquipeVendasController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { UsuarioInterface } from "../../../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";
import DesvincularEquipeUsuario from "./DesvincularEquipeUsuario/DesvincularEquipeUsuario";
import VincularEquipeUsuario from "./VincularEquipeUsuario/VincularEquipeUsuario";
import { IEquipeVendasPorUsuario } from "../../../../../Interfaces/Vendas/EquipeVendas/EquipeVendasInterfaces";

interface EquipeVendasProps {
    USER: UsuarioInterface;
}

export default function EquipeVendas(props: EquipeVendasProps) {
    const [lstSelecionadosVinculados, setLstSelecionadosVinculados] = useState<
        Array<IEquipeVendasPorUsuario>
    >([]);

    const [lstSelecionadosNaoVinculados, setLstSelecionadosNaoVinculados] =
        useState<Array<IEquipeVendasPorUsuario>>([]);

    const {
        value: lstEquipeVendasDesvinculadas,
        loading: lstEquipeVendasDesvinculadasLoading,
        execute: ListarEquipeVendasDesvinculadosPorUsuario,
    } = useAsyncEffect(async () => {
        if (props.USER.ID_USUARIO)
            return ListarEquipeVendasDesvinculadosPorUsuarioController(
                props.USER.ID_USUARIO
            );
    }, [props.USER.ID_USUARIO]);

    const {
        value: lstEquipeVendasVinculadas,
        loading: lstEquipeVendasVinculadasLoading,
        execute: ListarEquipeVendasVinculadosPorUsuario,
    } = useAsyncEffect(async () => {
        if (props.USER.ID_USUARIO)
            return ListarEquipeVendasVinculadosPorUsuarioController(
                props.USER.ID_USUARIO
            );
    }, [props.USER.ID_USUARIO]);

    const {
        execute: VincularEquipeVendasUsuario,
        loading: VincularEquipeVendasUsuarioLoading,
    } = useAsyncCallback(VincularEquipeVendasUsuarioController);

    const {
        execute: DesvincularEquipeVendasUsuario,
        loading: DesvincularEquipeVendasUsuarioLoading,
    } = useAsyncCallback(DesvincularEquipeVendasUsuarioController);

    return (
        <div className="Row2 flex-lg-row-fluid d-flex flex-column flex-lg-row mt-5">
            <div className="col-12 col-lg-6">
                <DesvincularEquipeUsuario
                    USER={props.USER}
                    lstEquipeVendasVinculadas={lstEquipeVendasVinculadas}
                    lstEquipeVendasVinculadasLoading={
                        lstEquipeVendasVinculadasLoading
                    }
                    DesvincularEquipeVendasUsuario={
                        DesvincularEquipeVendasUsuario
                    }
                    DesvincularEquipeVendasUsuarioLoading={
                        DesvincularEquipeVendasUsuarioLoading
                    }
                    lstSelecionadosNaoVinculados={lstSelecionadosNaoVinculados}
                    setLstSelecionadosNaoVinculados={
                        setLstSelecionadosNaoVinculados
                    }
                    ListarEquipeVendasDesvinculadosPorUsuario={
                        ListarEquipeVendasDesvinculadosPorUsuario
                    }
                    ListarEquipeVendasVinculadosPorUsuario={
                        ListarEquipeVendasVinculadosPorUsuario
                    }
                />
            </div>
            <div className="col-12 col-lg-6">
                <VincularEquipeUsuario
                    USER={props.USER}
                    lstEquipeVendasDesvinculadas={lstEquipeVendasDesvinculadas}
                    lstEquipeVendasDesvinculadasLoading={
                        lstEquipeVendasDesvinculadasLoading
                    }
                    VincularEquipeVendasUsuario={VincularEquipeVendasUsuario}
                    VincularEquipeVendasUsuarioLoading={
                        VincularEquipeVendasUsuarioLoading
                    }
                    lstSelecionadosVinculados={lstSelecionadosVinculados}
                    setLstSelecionadosVinculados={setLstSelecionadosVinculados}
                    ListarEquipeVendasDesvinculadosPorUsuario={
                        ListarEquipeVendasDesvinculadosPorUsuario
                    }
                    ListarEquipeVendasVinculadosPorUsuario={
                        ListarEquipeVendasVinculadosPorUsuario
                    }
                />
            </div>
        </div>
    );
}
